var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { getResourceName } from '@/shared/components/ResourceName';
var QUERY_KEY = 'RegistrationResources';
var useGetRegistrationResources = function (type) {
    if (type === void 0) { type = 0; }
    var intl = useIntl();
    return useQuery([QUERY_KEY, type], function () {
        return api.base
            .get('/api/resource/Registration', { params: { type: type } })
            .then(function (res) {
            return res.data.map(function (x) {
                var _a;
                return (__assign(__assign({}, x), { code: x.code || '', displayName: (_a = getResourceName(intl, x)) !== null && _a !== void 0 ? _a : x.name }));
            });
        });
    }, {
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    });
};
export default useGetRegistrationResources;
